import { useEffect, useState } from "react";
import { Icon, Wrapper } from "nystem-components";

const formatDate = (value) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return date.toISOString().replace(/[-:]/g, "").replace(/\.\d{3}/, "");
};

const CalendarLinkInput = ({ view }) => {
  const [value, setValue] = useState(view.value);

  useEffect(() => view.on("change", ({ value }) => setValue({ ...value })), [view]);

  const start = formatDate(value.execution || value.meet);
  const endDate = start ? new Date(value.execution || value.meet) : null;
  if (endDate) endDate.setHours(endDate.getHours() + 2);
  const end = formatDate(endDate);
  const details = [value.quoteText, value.riskAnalysis].filter(Boolean).join("\n\n");
  const params = new URLSearchParams({
    action: "TEMPLATE",
    text: value.name || "Arbor Syd assignment",
    dates: `${start}/${end}`,
    details,
  });

  return (
    <Wrapper className="rounded-lg border border-emerald-200 bg-emerald-50 p-4">
      <a
        href={start ? `https://calendar.google.com/calendar/render?${params}` : undefined}
        target="_blank"
        rel="noreferrer"
        aria-disabled={!start}
        className={[
          "inline-flex items-center gap-2 rounded-lg px-4 py-2 font-semibold text-white",
          start ? "bg-emerald-800 hover:bg-emerald-900" : "cursor-not-allowed bg-stone-400",
        ]}
      >
        <Icon icon="calendar-plus" className="h-4 w-4" />
        Add assignment and quote to Google Calendar
      </a>
      {!start && <p className="mt-2 text-sm text-stone-600">Choose a meeting or execution date first.</p>}
    </Wrapper>
  );
};

export default CalendarLinkInput;
